<template>
  <div>
    <v-navigation-drawer
      permanent
      app
      color="#00475A"
      style="margin-top: 58px; padding-bottom: 60px"
      dark
      width="239"
    >
      <v-list>
        <v-list-group
          :value="account"
          prepend-icon="mdi-account-circle"
          class="menu-text"
          v-if="isTokenActive"
        >
          <template v-slot:activator>
            <v-list-item-title>{{
              $t("message.aside.account", { value: "default" })
            }}</v-list-item-title>
          </template>
          <router-link to="/team" exact-path id="team">
            <v-list-item>
              <v-list-item-icon></v-list-item-icon>
              <v-list-item-title>{{
                $t("message.aside.profil", { value: "default" })
              }}</v-list-item-title>
            </v-list-item>
          </router-link>
          <router-link to="/alert/battery" id="alert" v-if="auth.myfleet">
            <v-list-item link>
              <v-list-item-icon></v-list-item-icon>
              <v-list-item-title>{{
                $t("message.aside.alert", { value: "default" })
              }}</v-list-item-title>
            </v-list-item>
          </router-link>

          <router-link to="/notice" exact-path id="notice">
            <v-list-item>
              <v-list-item-icon></v-list-item-icon>
              <v-list-item-title>{{
                $t("message.aside.notice", { value: "default" })
              }}</v-list-item-title>
            </v-list-item>
          </router-link>
        </v-list-group>

        <router-link to="/" exact-path v-if="auth.dashboard">
          <v-list-item link>
            <v-list-item-icon>
              <v-icon> mdi-view-dashboard </v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{
              $t("message.aside.board", { value: "default" })
            }}</v-list-item-title>
          </v-list-item>
        </router-link>

        <v-list-group
          :value="train"
          prepend-icon="mdi-train"
          v-if="auth.myfleet"
        >
          <template v-slot:activator>
            <v-list-item-title>{{
              $t("message.aside.parc", { value: "default" })
            }}</v-list-item-title>
          </template>

          <router-link to="/geoloc" exact-path>
            <v-list-item>
              <v-list-item-icon></v-list-item-icon>
              <v-list-item-title>{{
                $t("message.aside.geo", { value: "default" })
              }}</v-list-item-title>
            </v-list-item>
          </router-link>

          <router-link to="/geofencing" exact-path>
            <v-list-item link>
              <v-list-item-icon> </v-list-item-icon>
              <v-list-item-title>{{
                $t("message.aside.geofencing", { value: "default" })
              }}</v-list-item-title>
            </v-list-item>
          </router-link>

          <router-link to="/flotte" exact>
            <v-list-item>
              <v-list-item-icon></v-list-item-icon>
              <v-list-item-title>{{
                $t("message.aside.detail", { value: "default" })
              }}</v-list-item-title>
            </v-list-item>
          </router-link>

         <router-link to="/disponibility" exact>
            <v-list-item>
              <v-list-item-icon></v-list-item-icon>
              <v-list-item-title>{{
                $t("message.aside.disponibility", { value: "default" })
              }}</v-list-item-title>
            </v-list-item>
          </router-link> 

          <router-link to="/km" exact>
            <v-list-item>
              <v-list-item-icon></v-list-item-icon>
              <v-list-item-title>{{
                $t("message.aside.km", { value: "default" })
              }}</v-list-item-title>
            </v-list-item>
          </router-link>

          <router-link to="/hm" exact>
            <v-list-item>
              <v-list-item-icon></v-list-item-icon>
              <v-list-item-title>{{
                $t("message.aside.hm", { value: "default" })
              }}</v-list-item-title>
            </v-list-item>
          </router-link>

          <router-link to="/infoBattery" exact>
            <v-list-item>
              <v-list-item-icon></v-list-item-icon>
              <v-list-item-title>{{
                $t("message.aside.battery", { value: "default" })
              }}</v-list-item-title>
            </v-list-item>
          </router-link>

          
        </v-list-group>
        <v-list-group
          :value="mint"
          prepend-icon="mdi-view-grid-plus-outline"
          v-if="auth.mymint"
        >
          <template v-slot:activator>
            <v-list-item-title>{{
              $t("message.aside.mint", { value: "default" })
            }}</v-list-item-title>
          </template>

          <router-link to="/mymint" exact-path>
            <v-list-item link>
              <v-list-item-icon> </v-list-item-icon>
              <v-list-item-title>{{
                $t("message.aside.magic", { value: "default" })
              }}</v-list-item-title>
            </v-list-item>
          </router-link>

          <router-link to="/infoloc" exact-path>
            <v-list-item link>
              <v-list-item-icon> </v-list-item-icon>
              <v-list-item-title>{{
                $t("message.aside.infoloc", { value: "default" })
              }}</v-list-item-title>
            </v-list-item>
          </router-link>

          <router-link to="/jobplan" exact-path >
            <v-list-item link>
              <v-list-item-icon> </v-list-item-icon>
              <v-list-item-title>{{
                $t("message.aside.jobplan", { value: "default" })
              }}</v-list-item-title>
            </v-list-item>
          </router-link>

          <router-link to="/history" exact-path>
            <v-list-item link>
              <v-list-item-icon> </v-list-item-icon>
              <v-list-item-title>{{
                $t("message.aside.history", { value: "default" })
              }}</v-list-item-title>
            </v-list-item>
          </router-link>

          
          <router-link to="/krefeldplan" exact-path>
            <v-list-item link>
              <v-list-item-icon> </v-list-item-icon>
              <v-list-item-title>{{
                $t("message.aside.krefeldplan", { value: "default" })
              }}</v-list-item-title>
            </v-list-item>
          </router-link>
        
        </v-list-group>

        
        <v-list-group
          :value="doc"
          prepend-icon="mdi-file-document-multiple"
          v-if="auth.myfleet"
        >
          <template v-slot:activator>
            <v-list-item-title>{{
              $t("message.aside.doc", { value: "default" })
            }}</v-list-item-title>
          </template>

          <router-link to="/edl" exact-path>
            <v-list-item link>
              <v-list-item-icon> </v-list-item-icon>
              <v-list-item-title
                >{{ $t("message.aside.edl", { value: "default" }) }}
              </v-list-item-title>
            </v-list-item>
          </router-link>

          <router-link v-if="profile?.extrawork" to="/quotes" exact-path>
            <v-list-item link>
              <v-list-item-icon> </v-list-item-icon>
              <v-list-item-title
                >{{ $t("message.extrawork.title", { value: "default" }) }}
              </v-list-item-title>
            </v-list-item>
          </router-link> 
          
        </v-list-group>
        <v-list-group
          :value="account"
          prepend-icon="mdi-account-badge"
          v-if="getterUser?.internal"
        >
          <template v-slot:activator>
            <v-list-item-title>{{
              $t("message.aside.admin", { value: "default" })
            }}</v-list-item-title>
          </template>
          <router-link to="/intern/loco" exact-path>
            <v-list-item>
              <v-list-item-icon></v-list-item-icon>
              <v-list-item-title>{{
                $t("message.aside.locoInternal", { value: "default" })
              }}</v-list-item-title>
            </v-list-item>
          </router-link>
        </v-list-group>
      </v-list>

      <template v-slot:append v-if="isTokenActive">
        <v-list>
          <v-list-item link to="/config" v-if="auth.it">
            <v-list-item-icon>
              <v-icon> mdi-cog </v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{
              $t("message.aside.config", { value: "default" })
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="signOut">
            <v-list-item-icon>
              <v-icon> mdi-logout </v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{
              $t("message.aside.logout", { value: "default" })
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getProfile } from "@/shared/UserProfile";
export default {
  methods: {
    ...mapActions("auth", {
      logout: "logout",
    }),
    ...mapActions("config", {
      loadDocConfig: "loadDocConfig",
    }),

    isAuthorized() {
      if (this.getterFunctionnalities.includes("all")) {
        this.auth = {
          dashboard: true,
          myfleet: true,
          mymint: true,
          alert: true,
          doc: true,
          it: true,
        };
      }

      if (this.getterCompany == "AKIEM") {
        this.auth.sop = true;
        this.auth.doc = true;
      }

      if (this.getterFunctionnalities.includes("mymint")) {
        this.auth.mymint = true;
      }

      if (this.getterFunctionnalities.includes("myfleet")) {
        this.auth = {
          dashboard: true,
          myfleet: true,
          mymint: true,
          alert: false,
          doc: true
        };
      }

      if (this.getterFunctionnalities.includes("it")) {
        this.auth.it = true;
      }
    },

    async getDocConfig() {
      await this.loadDocConfig();
    },

    signOut() {
      this.logout();
      this.$router.push("/login");
    },

    getActive() {
      let active = this.$route.name;

      const trainRoutes = [
        "DispoPage",
        "MonitoringPage",
        "KmPage",
        "GeolocPage",
        "JobPlanPage",
        "GeofencingPage",
        "HmPage",
        "InfoBatteryPage",
        "DisponibilityPage"
      ];
      const accountRoutes = ["TeamPage", "NoticePage", "AlertBatteryPage"];
      const mintRoutes = [
        "MagicPage",
        "InfoLocoPage",
        "HistoryPage",
        "JobPlanPage",
        "KrefeldPlan",
        "InfoLocoPage",
        "KrefeldDocuments",
      ];

      const docRoutes = ["EdlPage", "CertificatPage", "QuotePage"];

      if (trainRoutes.indexOf(active) >= 0) {
        this.train = true;
        this.account = false;
        this.mint = false;
        this.doc = false;
      }

      if (docRoutes.indexOf(active) >= 0) {
        this.train = false;
        this.account = false;
        this.mint = false;
        this.doc = true;
      }

      if (accountRoutes.indexOf(active) >= 0) {
        this.train = false;
        this.account = true;
        this.mint = false;
        this.doc = false;
      }

      if (mintRoutes.indexOf(active) >= 0) {
        this.train = false;
        this.account = false;
        this.mint = true;
        this.doc = false;
      }
    },
  },
  mounted() {
    this.isAuthorized();
    this.getActive();
    this.getDocConfig();
    this.profile = getProfile(this.getterProfils,this.getterFunctionnalities);
  },
  computed: {
    ...mapGetters("config", {
      getterDoc: "getDocument",
    }),

    ...mapGetters("auth", {
      getterFunctionnalities: "getFunctionnalities",
      getterCompany: "getCompany",
      getterProfils: "getProfils",
      isTokenActive: "isTokenActive",
      getterUser: "getUserContact",
    }),
  },
  name: "PortalAside",
  data: () => ({
    train: false,
    mint: false,
    account: false,
    schedule: false,
    sop: false,
    doc: false,
    auth: {
      dashboard: false,
      myfleet: false,
      mymint: false,
      alert: false,
      it: false,
    },
    profile : {
      extrawork: false,
      validateQuote: false,
      rejectQuote: false,
    },
  }),
};
</script>

<style scoped>
.v-list-item__title {
  font-size: 0.85em;
}

.router-link-exact-active > div {
  color: #fff;
  background-color: #003441;
}

.router-link-exact-active[href="/team"] > div {
  color: #fff;
  background-color: #6db7a2;
}

.router-link-exact-active[href="/notice"] > div {
  color: #fff;
  background-color: #6db7a2;
}
.router-link-active[href="/alert/battery"] > div {
  color: #fff;
  background-color: #6db7a2;
}

.v-list {
  padding: 0px;
}

.menu-text {
  background-image: url("../assets/background_account.svg");
  background-size: auto;
  background-color: #7fc7b2;
}
</style>
